export default __webpack_public_path__ + "static/media/gw6.6efb4a6a.webp";